import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { GetStoreDetailPayload, PremiumStores, PremiumStoresListParams, StatusType } from './premiumStores.types';

export const getPremiumStoresList = (client: AxiosInstance) => async (params?: PremiumStoresListParams) => {
  return (
    await client.get<PaginatedApiResponse<PremiumStores[]>>(API_ROUTES.GET_PREMIUM_STORE_LIST, {
      params: { ...params },
    })
  ).data;
};

export const getPremiumStoresDetails = (client: AxiosInstance) => async (params?: GetStoreDetailPayload) => {
  return (await client.get<PaginatedApiResponse<PremiumStores>>(API_ROUTES.GET_PREMIUM_STORE_DETAILS, { params })).data;
};

export const premiumStoresListQueries = {
  all: (type: StatusType) => [type, 'premiumStores'],
  list: (type: StatusType, params?: PremiumStoresListParams) =>
    queryFactoryOptions<PaginatedApiResponse<PremiumStores[]>>({
      queryKey: [type, 'premiumStores', 'list', params],
      queryFn: (client: AxiosInstance) => () => getPremiumStoresList(client)(params),
    }),
  detail: (type: StatusType, params?: GetStoreDetailPayload) =>
    queryFactoryOptions<PaginatedApiResponse<PremiumStores>>({
      queryKey: [...premiumStoresListQueries.all(type), 'detail', params],
      queryFn: (client: AxiosInstance) => () => getPremiumStoresDetails(client)(params),
    }),
};
